// 日本語。型は `Messages` — en.ts にキーを足してここに足し忘れると
// コンパイルエラーになる。英語のまま漏れることはない。

import type { Messages } from './en';

export const ja: Messages = {
  "web.severity": "重要度",
  "web.title": "Web モニタリング",
  "web.description": "実ユーザーの訪問、JavaScript エラー、独立したブラウザ検査",
  "web.chooseApp": "このプロジェクトの Web App を選択",
  "web.noApps": "明示的な識別子を持つ Web App を作成して訪問を収集します",
  "web.performance": "パフォーマンス",
  "web.checks": "検査",
  "web.errors": "エラー",
  "web.visits": "サンプル訪問",
  "web.documents": "ドキュメント訪問",
  "web.errorRate": "訪問エラー率の推定",
  "web.rumHint": "分位数は端末別のサンプル訪問から算出します。ドキュメント指標と SPA の準備時間は別です。データなしは合格ではありません。",
  "web.samples": "サンプル数",
  "web.device": "端末",
  "web.mobile": "モバイル",
  "web.desktop": "デスクトップ",
  "web.all": "すべて",
  "web.environment": "環境",
  "web.release": "リリース",
  "web.route": "ルートテンプレート",
  "web.hours": "期間（時間）",
  "web.metric": "指標",
  "web.assessment": "評価",
  "web.insufficient": "データ不足",
  "web.attention": "要確認",
  "web.good": "良好",
  "web.observed": "観測済み",
  "web.coverage": "欠測指標の内訳",
  "web.recent": "最近の訪問",
  "web.diagnostics": "診断情報",
  "web.empty": "この範囲の観測はありません",
  "web.errorHint": "最新 500 件のエラーが対象です。関連訪問は任意の RUM コンテキストを持つイベントのみです",
  "web.occurrences": "件数",
  "web.correlated": "関連訪問",
  "web.lastSeen": "最終検出",
  "web.create": "検査を作成",
  "web.edit": "検査を編集",
  "web.run": "今すぐ実行",
  "web.refresh": "更新",
  "web.runnerMissing": "ブラウザランナーが未設定のため検査を実行できません",
  "web.labHint": "ラボ結果は実ユーザーの分位数とは別です。TBT は INP ではありません。検索エンジンのインデックス状況は測定しません。",
  "web.name": "名前",
  "web.url": "URL",
  "web.policy": "ページ方針",
  "web.public": "公開・インデックス対象",
  "web.private": "非公開・noindex",
  "web.ready": "準備完了要素のセレクター",
  "web.auth": "ランナー認証プロファイル名",
  "web.authHint": "認証情報はランナーに保持し、プロジェクトと App ごとに分離します",
  "web.origins": "追加の公開オリジン（1 行に 1 件）",
  "web.schedule": "定期検査を有効化",
  "web.interval": "間隔（秒、最小 900）",
  "web.lighthouse": "Lighthouse パフォーマンス監査を実行",
  "web.alerts": "継続障害と復旧時に通知",
  "web.threshold": "通知までの連続失敗回数",
  "web.advanced": "操作手順（JSON、任意）",
  "web.stepsHint": "click、waitFor、assertText に対応します。専用アカウントで読み取り専用の操作を設定してください。",
  "web.save": "保存",
  "web.cancel": "キャンセル",
  "web.delete": "検査と履歴を削除",
  "web.confirmDelete": "削除を確定",
  "web.failed": "操作に失敗しました",
  "web.findings": "検出事項",
  "web.rule": "ルール",
  "web.evidence": "根拠",
  "web.advice": "修正案",
  "web.profile": "測定条件とツール版",
  "web.queued": "待機中",
  "web.running": "実行中",
  "web.passed": "合格",
  "web.siteFailed": "検査不合格",
  "web.monitorError": "モニター実行エラー",
  "web.cancelled": "キャンセル済み",
  "web.unknown": "未検査",
  "web.degraded": "失敗を検出",
  "web.failing": "継続的な失敗",
  "web.noFindings": "検査範囲内で問題は検出されませんでした",
  "web.retention": "保持期間：{days} 日",
  "web.sampleRates": "サンプリング確率",
  "web.history": "最近の実行履歴",
  "web.budgetLcp": "LCP 上限（ms）",
  "web.budgetTbt": "TBT 上限（ms）",
  "web.budgetCls": "CLS 上限",

  "releaseView.noFiles": "デバッグファイルは未アップロードです",
  "releaseView.uploadedUnchecked": "ファイルを保存しました。形式は未確認です。",
  "releaseView.cliHint": "sentori で設定、ソース収集、デバッグファイルのアップロード、保存内容の検証を行えます。Git は任意です。利用する場合は --git-tag でタグを指定します。",
  "releaseView.sourceZipHint": "このビルドの UTF-8 ソースを、プロジェクト相対パスを保った ZIP でアップロードできます。展開後は最大 64 MiB、各ファイルは最大 512 KiB。旧形式のソース JSON にも対応します。",
  "releaseView.validationHint": "アップロード済みのデバッグファイルを種類別に表示します。形式の確認だけではビルドやイベントとの一致は保証されません。JavaScript を実行しないネイティブアプリに Source Map は不要です。",
  "releaseView.fileStatus": "{kind}：{status} · {count} ファイル",
  "releaseView.notUploaded": "未アップロード",
  "artifact.sourceMap": "Source Map（ソースマップ）",
  "artifact.dsym": "dSYM",
  "artifact.proguard": "ProGuard マッピング",
  "artifact.sourceBundle": "ソースバンドル",
  "bench.noDocuments": "開いているタブはありません",
  "bench.openDocument": "ナビゲーションやリソース一覧からページを開いてください",
  "bench.reopenDocument": "直前のページを開く",
  "releaseView.selected": "選択中のリリース",
  "releaseView.backToList": "一覧に戻る",
  "releaseView.outsideList": "選択中のリリースは現在の検索結果に含まれません",
  "releaseView.sections": "リリース詳細のセクション",
  "shell.saasBy": "{name} 提供の SaaS",
  "shell.saas": "Sentori Cloud · SaaS",
  "shell.selfHostedBy": "{operator} がセルフホスト · {name}",
  "shell.selfHostedInstance": "セルフホスト · {name}",
  "shell.selfHosted": "セルフホストインスタンス",
  "shell.instanceUnknown": "インスタンス情報を取得できません",
  "shell.instanceDetails": "インスタンスとバージョン",
  "shell.interfaceVersion": "管理画面 {version}",
  "shell.serviceVersion": "データサービス {version}",
  "shell.interface": "管理画面のバージョン",
  "shell.service": "データサービスのバージョン",
  "shell.deploymentMode": "デプロイ方式",
  "shell.operator": "サービス運営者",
  "shell.operatorUnknown": "インスタンス運営者が未設定です",
  "shell.productCredit": "Sentori は GOLIA が開発しています。このインスタンスは上記のサービス運営者が運用しています。",

  "bench.projectSwitcher": "ワークスペースのプロジェクト",
  "filters.advanced": "詳細フィルター",
  "bench.title": "ワークベンチ",
  "bench.explorer": "リソース",
  "bench.inspector": "インスペクター",
  "bench.activity": "アクティビティ",
  "bench.toggleExplorer": "リソースパネルを切り替え",
  "bench.toggleInspector": "インスペクターを切り替え",
  "bench.toggleActivity": "下部パネルを切り替え",
  "bench.reset": "レイアウトをリセット",
  "bench.resize": "{name}のサイズを変更",
  "bench.tabs": "調査タブ",
  "bench.tabHint": "矢印キーでタブを切り替え、Alt + 矢印キーで並べ替え",
  "bench.closeTab": "{name}を閉じる",
  "bench.moved": "{name}を{total}件中{position}番目に移動",
  "bench.recent": "全{total}件中、最新{count}件",
  "bench.empty": "記録はありません",
  "bench.loadFailed": "リソースを読み込めませんでした",
  "bench.selectIssue": "問題を選択すると対応履歴を表示します",
  "bench.context": "現在のコンテキスト",
  "bench.project": "プロジェクト",
  "bench.status": "状態",
  "bench.release": "リリース",
  "bench.environment": "環境",
  "bench.events": "イベント",
  "bench.platform": "プラットフォーム",
  "bench.issues": "問題",
  "bench.releases": "リリース",
  "inspect.event": "現在のイベント",
  "inspect.frame": "選択したフレーム",
  "inspect.frameNumber": "フレーム {n}",
  "inspect.function": "関数",
  "inspect.location": "ソースの位置",
  "inspect.sourceAvailable": "このフレームを展開するとソースを確認できます",
  "inspect.selectFrame": "スタックフレームを選択すると、完全な位置とソースの状態を確認できます",
  "inspect.eventContext": "イベントの情報",
  "inspect.backToEvent": "イベントに戻る",
  "inspect.identifiers": "識別子とアドレス",
  "inspect.imageBase": "イメージのベースアドレス",
  "bench.selection": "リソースを開くと詳細を表示します",
  "bench.unknown": "未指定",

  "queue.shortcutButton": "ショートカット",
  "queue.shortcutMove": "問題を移動",
  "queue.shortcutOpen": "問題を開く",
  "queue.shortcutSelect": "問題を選択",
  "crashFree.emptyHint": "クライアントからセッションを受信すると統計を表示します",
  "apps.unidentified": "未識別のアプリ · {platform}",
  "apps.unidentifiedData": "未識別のデータ",
  "apps.unidentifiedHint": "アプリを特定できないイベントはアプリ数に含めません",
  "apps.events24h": "24 時間のイベント {count} 件",
  "apps.inferredName": "リリース名から推定、未確認",
  "apps.nameSource": "名前の取得元",
  "apps.identifier": "アプリ識別子",
  "apps.sourceConfigured": "プロジェクト所有者が設定",
  "apps.sourceReported": "クライアントが送信したアプリ識別子",
  "apps.sourceRelease": "リリース名から推定",
  "apps.sourceUnknown": "アプリを特定できません",
  'apps.title': "アプリ",
  'apps.all': "すべてのアプリ",
  'apps.loadFailed': "アプリを読み込めません",
  'apps.platforms': "検出されたプラットフォームと導入ガイド",
  'apps.filesOnly': "ファイルをアップロード済み",
  'apps.empty': "データを受信するとアプリを自動で識別します。上のプラットフォームから導入ガイドを開けます",
  'apps.edit': "アプリを編集",
  'apps.create': 'アプリを追加',
  'apps.identifierHint': 'SDK が送信する識別子（Bundle ID、パッケージ名、または設定した App identifier）を入力します。',
  'apps.kind': 'アプリの種類',
  'apps.name': "アプリ名",
  'apps.repository': "Git リポジトリ",
  'apps.repositoryHint': "このアプリのリポジトリ URL",
  'apps.conflict': "アプリが変更されました。ダイアログを閉じて再読み込みしてください",

  "instanceHealth.title": "インスタンス健全性チェック",
  "instanceHealth.hint": "読み取り専用です。テストデータの書き込みや外部接続は行いません。バックアップ履歴だけでは外部コピーや復元の成功は確認できません",
  "instanceHealth.run": "健全性を確認",
  "instanceHealth.unknownCheck": "その他のチェック",
  "instanceHealth.unknownReason": "この結果を表示できません。サーバーと画面のバージョンを確認してください",
  "instanceHealth.status.pass": "正常",
  "instanceHealth.status.warning": "対応が必要",
  "instanceHealth.status.fail": "失敗",
  "instanceHealth.status.unknown": "未確認",
  "instanceHealth.check.database": "データベース接続",
  "instanceHealth.check.schema": "データベース構造",
  "instanceHealth.check.instance": "インスタンス識別と状態",
  "instanceHealth.check.backup": "直近のバックアップ記録",
  "instanceHealth.check.operations": "インスタンス運用タスク",
  "instanceHealth.check.storage": "永続ストレージ",
  "instanceHealth.check.recovery": "災害復旧の検証",
  "instanceHealth.reason.database_reachable": "データベースへの問い合わせに成功",
  "instanceHealth.reason.database_unavailable": "データベースに接続できません。接続先、サービス、認証情報を確認してください",
  "instanceHealth.reason.metadata_unavailable": "診断情報を読み取れません。データベースのバージョンと権限を確認してください",
  "instanceHealth.reason.schema_matches_binary": "マイグレーションのバージョンとチェックサムが実行中のプログラムと一致",
  "instanceHealth.reason.schema_mismatch": "マイグレーションが一致しません。更新またはロールバックのバージョンを確認してください",
  "instanceHealth.reason.instance_ready": "初期設定済みで通常運用モード",
  "instanceHealth.reason.recovery_validation_active": "復元検証モードです。データを検証してからバックグラウンド処理を再開してください",
  "instanceHealth.reason.setup_incomplete": "インスタンスの初期設定を完了してください",
  "instanceHealth.reason.instance_identity_invalid": "インスタンス識別または動作モードが単一主体の条件を満たしていません",
  "instanceHealth.reason.recent_backup_record": "24 時間以内の完了記録があります。今回はアーカイブ自体を読み取っていません",
  "instanceHealth.reason.backup_record_stale": "直近のバックアップは 24 時間より前です。実行予定を確認してください",
  "instanceHealth.reason.backup_clock_invalid": "バックアップ時刻が不正です。サーバーの時計を確認してください",
  "instanceHealth.reason.backup_record_missing": "現在のインスタンス世代に完了記録がありません。バックアップを作成して別の場所に保存してください",
  "instanceHealth.reason.lifecycle_operation_stalled": "長時間待機中またはリース切れのタスクがあります。操作履歴とサービスログを確認してください",
  "instanceHealth.reason.no_stalled_lifecycle_operations": "長時間待機中またはリース切れの運用タスクはありません",
  "instanceHealth.reason.storage_not_persistent": "永続ストレージが未設定です。再起動で添付データが失われる可能性があります",
  "instanceHealth.reason.storage_directory_readable": "ディレクトリを読み取れます。書き込み、空き容量、全ファイルの整合性は未検証です",
  "instanceHealth.reason.storage_directory_unreadable": "ストレージを読み取れません。マウントと権限を確認してください",
  "instanceHealth.reason.recovery_not_verified": "外部コピー、復旧キー、実際の復元は未検証です。別環境でバックアップ検証と復元訓練を行ってください",

  "cloud.renameWorkspace": "ワークスペース名を変更",
  "cloud.renameOrganization": "組織名を変更",
  "cloud.orgOwner": "組織オーナー",
  "cloud.orgMember": "組織メンバー",
  "cloud.makeOwner": "オーナーに変更",
  "cloud.makeMember": "メンバーに変更",
  "cloud.removeMember": "メンバーを削除",
  "cloud.memberChangeHint": "{email} の権限を変更します。組織オーナーはすべてのワークスペースと請求を管理できます。メンバーを削除すると、ワークスペースへのアクセスが直ちに失われます。",
  "cloud.provisioningFailed": "ワークスペースの準備に失敗しました。再試行すると既存のリソースで続行します。",
  "cloud.provisioningWait": "支払いは確認済みです。ワークスペースの開設をお待ちください。この画面の実際の状態をご確認ください。",
  "cloud.quote": "プランの見積もり",
  "cloud.plan": "プラン",
  "cloud.month": "月",
  "cloud.year": "年",
  "cloud.requestQuote": "見積もりを作成",
  "cloud.billing": "サブスクリプションと請求",
  "cloud.checkoutUnavailable": "購入はまだ開始されていません",
  "cloud.internalWorkspace": "運営者が提供する社内ワークスペース",
  "cloud.trialWorkspace": "トライアルワークスペース",
  "cloud.testBilling": "現在はテスト決済環境です。正式サービスの開始を意味するものではありません。",
  "cloud.paymentStatus": "支払い状況",
  "cloud.paidUntil": "支払い済みの利用期限：{time}",
  "cloud.continueCheckout": "決済ページへ進む",
  "cloud.retryVerification": "支払いを再確認",
  "cloud.renewalCancelled": "今期終了後の自動更新は停止しています",
  "cloud.renewalActive": "自動更新が有効です",
  "cloud.resumeRenewal": "自動更新を再開",
  "cloud.cancelRenewal": "自動更新を停止",
  "cloud.invoices": "支払い済みの請求書",
  "cloud.workspaceMembers": "ワークスペースのアクセス権",
  "cloud.workspaceMembersHint": "組織の owner は自動的に管理権限を持ちます。一般メンバーには個別の許可が必要です。プロジェクトメンバーには初回ログイン後にプロジェクトを割り当ててください。",
  "cloud.revokeAccess": "アクセス権を取り消す",
  "cloud.selectMember": "組織のメンバーを選択",
  "cloud.grantAccess": "アクセス権を保存",
  "cloud.renewalHint": "操作は決済サービスが処理し、結果を確認します。更新を停止しても支払い済みの期限までは利用でき、確認前に成功とは表示されません。",
  "cloud.quoteExpires": "見積もりの承諾期限：{time}",
  "cloud.serviceTerms": "利用規約",
  "cloud.privacy": "プライバシー規約",
  "cloud.refunds": "返金規約",
  "cloud.agreeTerms": "上記の規約（バージョン {revision}）を読み、同意します",
  "cloud.acceptQuote": "見積もりを承認して決済を準備",
  "cloud.taxIncluded": "税込み",
  "cloud.taxExtra": "税額は決済時に計算",

  "cloud.signIn": "Sentori Cloud にログイン",
  "cloud.register": "Cloud アカウントを登録",
  "cloud.verify": "アカウントの確認",
  "cloud.linkSent": "条件に該当する場合、確認メールを送信キューに追加しました。受信箱をご確認ください。",
  "cloud.emailFirst": "メールを確認してからパスワードを設定します",
  "cloud.displayName": "表示名",
  "cloud.mailUnavailable": "メールサービスはまだ設定されていません。後ほどお試しください。",
  "cloud.actionFailed": "操作を完了できませんでした。原因を確認して再試行してください。",
  "cloud.sendLink": "確認メールを送信",
  "cloud.accessInvalid": "ログイン要求が無効です。ワークスペースからやり直してください。",
  "cloud.enter": "ワークスペースを開く",
  "cloud.console": "Cloud コンソール",
  "cloud.signOut": "Cloud からログアウト",
  "cloud.organizations": "組織",
  "cloud.passwordSessions": "パスワードを変更すると、すべての Cloud セッションとワークスペースへのログインが解除されます。再ログインしてください。",
  "cloud.invitations": "保留中の招待",
  "cloud.acceptInvitation": "招待を承認",
  "cloud.previous": "前のページ",
  "cloud.next": "次のページ",
  "cloud.organizationName": "組織名",
  "cloud.createOrganization": "組織を作成",
  "cloud.workspaces": "ワークスペース",
  "cloud.manageWorkspace": "ワークスペースを管理",
  "cloud.workspaceName": "ワークスペース名",
  "cloud.region": "データリージョン",
  "cloud.createWorkspace": "ワークスペースの下書きを作成",
  "cloud.catalogUnavailable": "運営者が利用可能なリージョンとプランをまだ設定していません",
  "cloud.members": "組織のメンバー",
  "cloud.inviteHint": "招待は受信者の Cloud コンソールに表示されます。現在、招待メールは送信されません。",
  "cloud.invite": "メンバーを招待",
  "cloud.revokeInvitation": "招待を取り消す",
  "cloud.state.draft": "下書き",
  "cloud.state.checkout": "決済待ち",
  "cloud.state.paid": "支払い済み、開設待ち",
  "cloud.state.provisioning": "開設中",
  "cloud.state.ready": "利用可能",
  "cloud.state.suspended": "一時停止中",
  "cloud.state.closed": "閉鎖済み",

  "cloud.workspace": "Cloud ワークスペース",
  "cloud.usage": "ワークスペース使用量",
  "cloud.usageFailed": "ワークスペースの使用量を読み込めませんでした",
  "cloud.events": "今月のイベント",
  "cloud.replays": "今月のリプレイ",
  "cloud.ingestBytes": "今月の受信バイト数",
  "cloud.artifactBytes": "ソース成果物の保存バイト数",
  "cloud.resetAt": "月間使用量は {time} にリセットされます（UTC の暦月）",
  "cloud.unavailable": "現在、受信の認可を確認できません",
  "cloud.retention": "イベント保存 {events} 日 · リプレイ保存 {replays} 日 · 毎秒最大 {rate} イベント",
  "cloud.trafficHint": "通信量は正規化 JSON とアップロードされたファイルの内容で計算し、受け付けた再送も含みます。データを削除しても月間使用量は減りません。",

  "auth.modeFailed": "ログイン方法を読み込めませんでした",
  "auth.cloudTitle": "Sentori Cloud",
  "auth.cloudHint": "このワークスペースへのアクセス権がある Cloud アカウントでログインしてください。",
  "auth.cloudManaged": "パスワードと組織のメンバー資格は Sentori Cloud で管理します。",
  "auth.cloudAccount": "Cloud アカウントを管理",
  "auth.cloudSignIn": "Cloud アカウントで続ける",
  "auth.cloudMembers": "メンバーは Sentori Cloud で管理します。メンバーが初めてこのワークスペースにログインした後、ここでプロジェクトを割り当てられます。",

  "lifecycle.database": "データベース",
  "lifecycle.files": "リプレイとソースファイル",
  "lifecycle.upload": "アップロードして検証",
  "lifecycle.verify": "アーカイブを検証",
  "lifecycle.uploadedArchive": "アップロードされたアーカイブ",
  "lifecycle.instanceBackup": "インスタンスのバックアップ",
  "lifecycle.sourceInstance": "元のインスタンス",
  "lifecycle.archiveFile": "暗号化バックアップファイル",
  "lifecycle.keyFile": "復旧キーファイル",
  "lifecycle.invalidKey": "このアーカイブ用に保存した、64 桁の 16 進数を含む復旧キーファイルを選択してください。",
  "lifecycle.uploadHint": "暗号化復旧アーカイブと対応するキーをアップロードし、独立した検証を行います。ファイルの検査のみで、データは復元しません。ブラウザーからは最大 1 GiB までアップロードできます。それ以上は operator CLI を使用してください。",
  "lifecycle.uploadTooLarge": "このアーカイブは 1 GiB を超えています。operator CLI で検証してください。",

  "reset.title": "インスタンスをリセット",
  "reset.hint": "最新のバックアップを作成・検証してからデータを削除し、初期設定をやり直します。",
  "reset.consequences": "プロジェクト、イベント、リプレイ、メンバー、セッション、認証情報、待機中の処理を削除します。インスタンス ID と名前は保持し、世代を更新します。オフラインツールが完全な暗号化バックアップを作成・検証してから削除します。既存の暗号化バックアップとデプロイ設定は引き続き運用者が管理します。",
  "reset.typeName": "インスタンス名を入力",
  "reset.typeId": "インスタンス ID を入力",
  "reset.typeGeneration": "インスタンスの世代を入力",
  "reset.password": "現在の所有者パスワード",
  "reset.acknowledge": "このインスタンスのデータが削除されることを理解しました。バックアップと操作記録は独立したストレージに保存し、復旧キーは別に保管します。",
  "reset.prepare": "オフラインリセットを準備",
  "reset.wrongPassword": "現在のパスワードが正しくありません。もう一度入力してください。",
  "reset.failed": "リセット許可を確認できませんでした。インスタンスを再読み込みして準備をやり直してください。新しい許可は前の許可を置き換えます。",
  "reset.prepared": "オフラインでのリセットを許可しました。データはまだ削除されていません。",
  "reset.expires": "許可の有効期限",
  "reset.downloadPermit": "リセット許可をダウンロード",
  "reset.storageStep": "許可をダウンロードし、独立した復旧ストレージを /recovery にマウントします。復旧キーは /keys/recovery.key に別途保管してください。例のパスは実際の操作環境に合わせてください。",
  "reset.stopStep": "このデータベースに接続するすべてのサーバーと他の運用コマンドを停止します。PostgreSQL は稼働させておきます。",
  "reset.executeStep": "インスタンスのデータベース接続とマスターキーを設定して下記のコマンドを実行します。最新のバックアップを作成し、読み戻して検証し、操作記録を保存した後にデータを削除します。",
  "reset.restartStep": "コマンドの成功後にのみサーバーを再起動します。初期設定用の所有者を設定し、環境を確認してインスタンスを初期化してください。",
  "reset.interrupted": "データベース削除後にファイルの削除が中断すると、サーバーは起動できません。バックアップ、キー、操作記録を保持し、下記のコマンドで削除を完了してください。保留状態を手動で解除しないでください。",
  "lifecycle.title": "セルフホスト",
  "lifecycle.description": "このインスタンス、暗号化バックアップ、復旧を管理します",
  "lifecycle.overview": "概要",
  "lifecycle.setup": "設定",
  "lifecycle.backups": "バックアップ",
  "lifecycle.activity": "操作履歴",
  "lifecycle.ownerOnly": "バックアップの作成とダウンロードはインスタンス所有者のみが行えます",
  "lifecycle.latestBackup": "最新の検証済みバックアップ",
  "lifecycle.noBackup": "利用可能なバックアップはありません",
  "lifecycle.generation": "世代",
  "lifecycle.recovery": "復旧",
  "lifecycle.offInstance": "アーカイブを別のストレージに保存してください。同じサーバー内のバックアップではサーバーの喪失に備えられません。復旧キーとインスタンスのマスターキーも別途保管してください。",
  "lifecycle.recoveryHint": "復旧先のサーバーを停止し、空のデータベースと新しいファイルディレクトリに復元します。検証モードで起動してリプレイとソースマップを確認し、旧インスタンスの停止を確認してからバックグラウンド処理を再開します。",
  "lifecycle.runbook": "デプロイと復旧ガイドを読む",
  "lifecycle.create": "バックアップを作成",
  "lifecycle.backupHint": "データベースと参照されるリプレイ・ソースファイルの整合性を保ったスナップショットを作成し、復旧キーで暗号化します。保存されたアーカイブを検証してからダウンロードできるようになります。",
  "lifecycle.encrypted": "暗号化復旧パッケージ",
  "lifecycle.configureHint": "サーバーに永続ファイルストレージ、SENTORI_MASTER_KEY、絶対パスの SENTORI_BACKUP_DIR を設定するとバックアップが有効になります。",
  "lifecycle.rows": "行",
  "lifecycle.cancelling": "キャンセル中",
  "lifecycle.verifying": "アーカイブを検証中",
  "lifecycle.state.queued": "待機中",
  "lifecycle.state.running": "作成中",
  "lifecycle.state.ready": "検証済み",
  "lifecycle.state.failed": "失敗",
  "lifecycle.state.cancelled": "キャンセル済み",
  "lifecycle.state.unavailable": "ファイルが利用不可",
  "lifecycle.reason.cancelled": "完了前に操作がキャンセルされました",
  "lifecycle.reason.instance_changed": "インスタンスが変更されました。現在のインスタンスで新しい操作を開始してください。",
  "lifecycle.reason.instance_restored": "この履歴は復元元のインスタンスのものです。元の保存先からアーカイブを取得してください。",
  "lifecycle.reason.key_unavailable": "保存された復旧キーを復号できません。インスタンスのマスターキーを確認してください。",
  "lifecycle.reason.capture_failed": "バックアップに失敗しました。サーバーのストレージとログを確認してから作成し直してください。",
  "lifecycle.reason.verification_failed": "検証に失敗しました。復旧キー、アーカイブの完全性、運用ツールのバージョンを確認してください。",
  "lifecycle.reason.retry_exhausted": "再試行の上限に達しました。サーバーログを確認してから新しい操作を開始してください。",
  "lifecycle.operationFailed": "この操作ではダウンロード可能なバックアップが作成されませんでした",
  "lifecycle.download": "アーカイブをダウンロード",
  "lifecycle.verifyHint": "バックアップと同じバージョンの CLI を使用してください。DATABASE_URL を空の復旧先に設定し、元の SENTORI_MASTER_KEY を別途設定します。このマスターキーはアーカイブに含まれません。ファイルの検証にはアーカイブと復旧キーのみが必要です。",
  "lifecycle.auditHint": "作成、キャンセル、検証完了、ダウンロード開始はインスタンスの監査ログに記録されます。ダウンロード開始は、別の場所への保存完了を証明するものではありません。",
  "lifecycle.openAudit": "監査ログを開く",
  "lifecycle.keyHint": "作成前に今回の復旧キーを保存してください。復号に必要で、履歴から再取得することはできません。サーバーは処理中のみ暗号化して一時保存し、完了後に削除します。",
  "lifecycle.saveKey": "復旧キーをダウンロード",
  "lifecycle.savedKey": "復旧キーを安全な場所に保存しました",
  "lifecycle.uncertain": "結果を確認できませんでした。再試行は同じコマンドを使用し、バックアップの重複作成を防ぎます。",

  "pushOps.stoppedKinds": "失敗・結果不明・キャンセル",
  "pushOps.deviceSearch": "ID・トークン末尾・アプリバージョンを検索",
  "pushOps.setupOnly": "設定チェックは認証情報と登録デバイスを確認します。実際の結果は配信履歴で確認してください。",
  "pushOps.setupReady": "設定上の問題は見つかりませんでした",

  "pushOps.description": "送信先を確認して通知を送り、実際の配信結果を確認します",
  "pushOps.accepted24h": "24 時間の受付数",
  "pushOps.liveDevices": "有効なデバイス",
  "pushOps.search": "通知のタイトル・本文を検索",
  "pushOps.provider": "プロバイダー",
  "pushOps.allProviders": "すべてのプロバイダー",
  "pushOps.retryVisible": "確認した失敗を再試行",
  "pushOps.status": "状態",
  "pushOps.retries": "再試行回数",
  "pushOps.created": "作成日時",
  "pushOps.details": "詳細",
  "pushOps.noSends": "条件に一致する通知はありません",
  "pushOps.confirmSend": "送信を確定",
  "pushOps.review": "通知を確認",
  "pushOps.queuedResult": "通知をキューに追加しました。結果は配信履歴で確認できます。",
  "pushOps.reviewDevice": "この通知は選択したデバイスに送信されます",
  "pushOps.chooseDevice": "登録済みデバイスを選択",
  "pushOps.credential": "認証情報",
  "pushOps.accepted": "プロバイダー受付",
  "pushOps.receipt": "SDK 受信確認",
  "pushOps.noReceipt": "SDK の受信確認はありません",
  "pushOps.attempts": "最近の送信試行",
  "pushOps.noAttempts": "ワーカーの送信記録はありません",
  "pushOps.duplicateAck": "この通知はすでに受け付けられた可能性があります。再試行すると重複送信されることを理解しました。",
  "pushOps.confirmRetry": "再試行を確定",
  "pushOps.bulkHint": "失敗した次の {count} 件を再試行します。続ける前に一覧を確認してください。",
  "pushOps.deviceScope": "デバイスの表示範囲",
  "pushOps.allDevices": "無効化されたデバイスを含むすべて",
  "pushOps.revoked": "無効",
  "pushOps.live": "有効",
  "pushOps.addressable": "ユーザー識別済み",
  "pushOps.yes": "はい",
  "pushOps.no": "いいえ",
  "pushOps.lastSeen": "最終接続",
  "pushOps.confirmRevoke": "無効化を確定",
  "pushOps.revoke": "デバイスを無効化",
  "pushOps.badStreak": "連続失敗回数",
  "pushOps.revokeHint": "この登録への通知を停止します。未送信の通知は送信前にキャンセルされます。",
  "pushOps.stagedHint": "新しい認証情報は待機状態で保存されます。検証後に切り替えられます。",
  "pushOps.vaultMissing": "プロバイダーの認証情報を追加する前に、インスタンスの暗号化キーを設定してください。",
  "pushOps.active": "使用中",
  "pushOps.staged": "待機中",
  "pushOps.verification": "前回の検証",
  "pushOps.unverified": "未検証",
  "pushOps.fileTooLarge": "64 KiB 以下の認証情報ファイルを選択してください",
  "pushOps.saveStaged": "待機中の認証情報を保存",
  "pushOps.uploadCredential": "認証情報ファイル",
  "pushOps.probe": "プロバイダーで検証",
  "pushOps.activate": "認証情報を有効化",
  "pushOps.encrypted": "暗号化して保存済み",
  "pushOps.legacy": "暗号化待ちの旧認証情報",
  "pushOps.forceAck": "この認証情報の有効性は未確認です。有効化すると配信に失敗する可能性があることを理解しました。",
  "pushOps.deleteHint": "削除すると、キュー内の通知を送信できなくなる可能性があります。上記の認証情報を確認してください。",
  "pushOps.confirmDelete": "削除を確定",
  "pushOps.join": "条件の組み合わせ",
  "pushOps.source": "条件の種類",
  "pushOps.key": "フィールド名",
  "pushOps.operator": "比較方法",
  "pushOps.value": "値",
  "pushOps.addCondition": "条件を追加",
  "pushOps.preview": "送信先を確認",
  "pushOps.matched": "件の一致するデバイス",
  "pushOps.previewExpires": "プレビューの有効期限",
  "pushOps.traits": "属性",
  "pushOps.state.queued": "待機中",
  "pushOps.state.sending": "送信中",
  "pushOps.state.sent": "プロバイダー受付済み",
  "pushOps.state.acknowledged": "SDK 受信確認済み",
  "pushOps.state.failed": "失敗",
  "pushOps.state.uncertain": "結果不明",
  "pushOps.state.cancelled": "キャンセル済み",
  "pushOps.verdict.ok": "検証済み",
  "pushOps.verdict.rejected": "拒否",
  "pushOps.verdict.malformed": "形式が無効",
  "pushOps.verdict.unreachable": "接続できません",
  "pushOps.verdict.limited": "権限制限",
  "pushOps.verdict.not_implemented": "検証は利用できません",

  "monitor.finalStatusHint": "リダイレクト後の最終ステータス：200–299 または 400–599。",
  "integration.title": "連携",
  "integration.description": "通知先を設定し、実際の送信結果を確認します",
  "integration.configuredHint": "「設定済み」は設定の保存を示します。送信の成否は履歴で確認してください。",
  "integration.email": "メール",
  "integration.unconfigured": "未設定",
  "integration.configured": "設定済み",
  "integration.hint.email": "このインスタンスに設定された SMTP サービスで送信します",
  "integration.hint.webhook": "署名と固定の送信 ID を持つ JSON 通知を送ります",
  "integration.hint.github": "Issue の書き込み権限を持つトークンでリポジトリに Issue を作成します。",
  "integration.hint.jira": "Jira Cloud v3 API で課題を作成します",
  "integration.destination": "送信先",
  "integration.smtpMissing": "このインスタンスでは SMTP が未設定です",
  "integration.configure": "設定",
  "integration.sendTest": "テスト送信",
  "integration.confirmSend": "送信する",
  "integration.exportTask": "外部の課題管理にコピー",
  "integration.exportHint": "このタスクのタイトルと説明で外部の課題を作成します。Sentori のタスク状態は変わりません。",
  "integration.createsTicket": "設定した外部プロジェクトに実際の課題を作成します",
  "integration.realSend": "設定した送信先へ実際に通知を送信します",
  "integration.queueHint": "リクエストは永続キューに保存されます。プロバイダーの応答は送信履歴で確認できます。",
  "integration.queuedHint": "キューに保存しました。送信履歴を更新して結果を確認してください。",
  "integration.token": "認証情報・署名キー",
  "integration.recipient": "宛先メールアドレス",
  "integration.jiraEndpoint": "Jira サイト URL",
  "integration.accountEmail": "Jira アカウントのメールアドレス",
  "integration.projectKey": "Jira プロジェクトキー",
  "integration.issueType": "Jira 課題タイプ ID",
  "integration.secretHint": "暗号化して保存します。新しい HTTP 連携には HTTPS が必要です。",
  "integration.keepSecret": "空欄なら保存済みの値を維持します。送信先を変える場合は認証情報を再入力してください。",
  "integration.events": "自動通知",
  "integration.autoSend": "選択したイベントで自動送信します。初期状態では何も選択されていません。",
  "integration.autoTickets": "選択したイベントごとに新しい外部課題を作成します。手動コピーのみの場合はすべて未選択にしてください。",
  "integration.event.issueNew": "新しい問題",
  "integration.event.issueRegressed": "問題の再発",
  "integration.event.taskAssigned": "タスクの割り当て",
  "integration.event.taskUpdated": "タスクの更新",
  "integration.deliveries": "送信履歴",
  "integration.noDeliveries": "送信記録はまだありません",
  "integration.state.queued": "待機中",
  "integration.state.running": "送信中",
  "integration.state.retryWait": "再試行待ち",
  "integration.state.delivered": "送信済み",
  "integration.state.failed": "失敗",
  "integration.state.uncertain": "結果未確認",
  "integration.state.cancelled": "キャンセル済み",
  "integration.attempt": "試行回数：{count} / 5",
  "integration.openExternal": "外部課題を開く",
  "integration.retry": "送信を再試行",
  "integration.uncertainHint": "接続やワーカーの停止前に送信先が受信した可能性があります。再試行前に送信先を確認してください。",
  "integration.retryHint": "同じ送信 ID で再試行し、現在の設定とアクセス権を再確認します",
  "integration.duplicateAck": "送信先を確認しました。再試行で重複が生じる可能性を了承します。",

  "monitor.title": "サービス状態",
  "monitor.description": "定期チェック、障害履歴、復旧通知",
  "monitor.publicOnly": "ポート 80・443 の公開 HTTP/HTTPS 宛先を確認します。内部ネットワークと URL 内の認証情報は使用できません。",
  "monitor.create": "モニターを追加",
  "monitor.edit": "モニターを編集",
  "monitor.empty": "このプロジェクトにモニターはありません",
  "monitor.unknown": "未計測",
  "monitor.operational": "正常",
  "monitor.degraded": "チェック失敗",
  "monitor.down": "障害発生",
  "monitor.paused": "一時停止",
  "monitor.availability": "稼働率・30 日間",
  "monitor.latency": "応答時間",
  "monitor.lastCheck": "最終チェック",
  "monitor.samples": "最近のチェック",
  "monitor.window": "現在の設定で過去 30 日間に {count} 回チェックしました",
  "monitor.incident": "連続失敗が設定した回数に達しました。チェックが成功すると障害を終了します。",
  "monitor.failureThreshold": "連続失敗回数",
  "monitor.checkNow": "今すぐ確認",
  "monitor.noHistory": "記録はまだありません",
  "monitor.incidents": "障害履歴",
  "monitor.recovered": "復旧",
  "monitor.name": "モニター名",
  "monitor.url": "ヘルスチェック URL",
  "monitor.intervalSeconds": "間隔（分）",
  "monitor.timeoutSeconds": "タイムアウト（秒）",
  "monitor.expectedStatus": "期待する HTTP ステータス",
  "monitor.editHint": "保存すると新しい計測期間が始まり、旧設定で実行中の結果は破棄されます。障害履歴は保持されます。",
  "monitor.deleteHint": "このモニターを削除して今後のチェックを停止しますか？既存の障害記録は保存されます。",
  "monitor.confirmDelete": "モニターを削除",

  "team.autoWork": "が作業を開始しました",
  "team.autoPrOpened": "がプルリクエストを作成しました",
  "team.autoPrMerged": "がプルリクエストをマージしました",
  "team.autoChecks": "が CI の結果を受信しました",
  "team.autoDeployment": "がデプロイ結果を受信しました",
  "team.commit": "コミット",
  "team.pullRequest": "プルリクエスト",
  "team.unitChecks": "ユニットテスト",
  "team.e2eChecks": "E2E テスト",
  "team.deployedRelease": "デプロイしたリリース",
  "team.passed": "成功",
  "team.checkFailed": "失敗",

  "team.markAllRead": "すべて既読にする",
  "team.formerAssignee": "以前のプロジェクトメンバー",
  "team.issueTask": "関連タスクを表示",

  "team.automation": "タスクの自動化",
  "team.integrationHint": "署名付きイベントで CI とデプロイシステムを接続します。検証にはリポジトリ、コミット、環境の一致が必要です。",
  "team.vaultRequired": "暗号化した認証情報を使用するには、サーバーで SENTORI_MASTER_KEY を設定してください。",
  "team.repository": "リポジトリ",
  "team.environment": "デプロイ環境",
  "team.enabled": "有効",
  "team.rotate": "署名キーを更新する（旧キーは無効になります）",
  "team.signingKey": "署名キー",
  "team.secretOnce": "表示は今回のみです。CI のシークレットストアに保存してください。",
  "team.endpoint": "Webhook URL",
  "team.signatureHelp": "X-Sentori-Timestamp（Unix 秒）と X-Sentori-Signature: sha256=<署名キーで timestamp + \".\" + 生の JSON に対して計算した HMAC-SHA256> を送信します。時刻の許容差は 5 分です。",

  "team.save": "保存",
  "team.cancel": "キャンセル",
  "team.search": "タスクを検索",

  "team.title": "タスク",
  "team.description": "タスクの分類から修正、レビュー、検証までを追跡します",
  "team.create": "タスクを作成",
  "team.edit": "タスクを編集",
  "team.taskTitle": "タイトル",
  "team.details": "説明",
  "team.kind": "種類",
  "team.task": "タスク",
  "team.bug": "不具合",
  "team.priority": "優先度",
  "team.urgent": "緊急",
  "team.high": "高",
  "team.normal": "通常",
  "team.low": "低",
  "team.assignee": "担当者",
  "team.unassigned": "未割り当て",
  "team.everyone": "全員",
  "team.mine": "自分の担当",
  "team.stage": "段階",
  "team.triage": "分類待ち",
  "team.ready": "着手待ち",
  "team.inProgress": "進行中",
  "team.review": "レビュー中",
  "team.verify": "検証中",
  "team.done": "完了",
  "team.cancelled": "キャンセル済み",
  "team.due": "期限",
  "team.reproduction": "再現手順",
  "team.rootCause": "原因",
  "team.view": "表示",
  "team.list": "リスト",
  "team.board": "ボード",
  "team.all": "すべて",
  "team.refresh": "更新",
  "team.pageHint": "全 {count} 件 · どちらの表示でも 1 ページ最大 50 件です。",
  "team.empty": "該当するタスクはありません",
  "team.failed": "共同作業データを更新できませんでした",
  "team.chooseProject": "タスクを表示するプロジェクトを選択してください",
  "team.uncertain": "応答を受信できませんでした。保存済みの操作を再試行し、結果を確認してください。",
  "team.conflict": "下書きは保持されています。タスクが変更された場合は編集画面を閉じ、更新してから最新の内容を編集してください。",
  "team.issue": "関連する問題",
  "team.manual": "段階を手動で変更",
  "team.manualHint": "手動完了は関連する問題を解決し、操作を記録します。CI やデプロイの検証済み状態にはなりません。",
  "team.evidence": "検証の証拠",
  "team.verified": "同一コミットの検証とデプロイが完了",
  "team.noEvidence": "ビルドの検証とデプロイの証拠はまだ揃っていません",
  "team.activity": "履歴",
  "team.system": "システム",
  "team.created": "がタスクを作成しました",
  "team.updated": "がタスクを更新しました",
  "team.stageChanged": "が段階を変更しました",
  "team.commented": "がコメントしました",
  "team.regressed": "が問題の再発により再開しました",
  "team.comment": "コメント",
  "team.mention": "メンション",
  "team.noMention": "メンションなし",
  "team.post": "コメントを投稿",
  "team.inbox": "個人の受信トレイ",
  "team.inboxDescription": "アクセスできるプロジェクトの割り当て、メンション、更新を確認します",
  "team.preferences": "通知設定",
  "team.unread": "未読",
  "team.archived": "アーカイブ済み",
  "team.inboxCount": "未読の通知 {count} 件",
  "team.inboxEmpty": "この表示に通知はありません",
  "team.assignment": "割り当て",
  "team.taskUpdates": "タスクの更新",
  "team.monitors": "監視の通知",
  "team.markRead": "既読にする",
  "team.markUnread": "未読にする",
  "team.archive": "アーカイブ",
  "team.restore": "受信トレイに戻す",

  "jobs.title": "保存済みイベントを再解析",
  "jobs.hint": "現在利用できるデバッグファイルで、タスク開始前の最新 20,000 件のエラーイベントを確認します。課題のグループ分けは変わりません。",
  "jobs.run": "再解析を開始",
  "jobs.refresh": "タスクを更新",
  "jobs.queued": "待機中",
  "jobs.running": "実行中",
  "jobs.retryWait": "再試行待ち",
  "jobs.succeeded": "完了",
  "jobs.failed": "失敗",
  "jobs.cancelled": "キャンセル済み",
  "jobs.actionFailed": "バックグラウンドタスクを更新できませんでした",
  "jobs.empty": "再解析タスクはまだありません",
  "jobs.progress": "確認 {scanned} 件 · 更新 {rewritten} 件 · 復元フレーム {frames} 件",
  "jobs.attempt": "試行 {attempt} / {max} 回",
  "jobs.limit": "今回の上限 20,000 件に達しました",
  "jobs.cancel": "タスクをキャンセル",
  "jobs.cancelling": "キャンセルを要求済み",
  "jobs.processingFailed": "処理に失敗しました。サーバーログで詳細を確認してください",
  "jobs.timeout": "イベントの処理がタイムアウトしました",
  "jobs.exhausted": "再試行回数の上限に達しました",
  "jobs.generationChanged": "インスタンスが変更されました。新しいタスクを開始してください",
  "detail.firstSeen": "初回発生",
  "detail.previousAssignee": "以前の担当者 · {id}",
  "detail.rawEvent": "イベントの原文",
  'releaseView.notFound': 'このプロジェクトではこのバージョンを表示できません',
  "releaseView.description": "リリースの状態と、スタックを読み解くためのファイルを確認します",
  "releaseView.search": "バージョンを検索",
  "releaseView.sessions": "セッション",
  "releaseView.artifacts": "デバッグファイル",
  "releaseView.created": "作成日時",
  "releaseView.healthFailed": "リリースの状態を読み込めませんでした",
  "releaseView.artifactFailed": "デバッグファイルを読み込めませんでした",
  "releaseView.window": "過去 30 日間",
  "releaseView.usable": "形式確認済み",
  "releaseView.unusable": "形式が無効",
  "releaseView.unchecked": "未検証",
  "releaseView.upload": "デバッグファイルをアップロード",
  "releaseView.file": "ファイル",
  "releaseView.fileHint": "gzip に対応しています。アップロードは 256 MiB 未満にし、対応するビルドのファイルを選んでください。",
  "releaseView.actionFailed": "アップロードに失敗しました。選択したファイルで再試行できます",
  "releaseView.uploaded": "ファイルを保存し、形式を確認しました。既存イベントを再処理します。ビルドとの一致はイベントごとに判定します。",
  "releaseView.uploadedInvalid": "ファイルは保存されましたが、シンボル解決には使用できません。種類とビルドを確認してください。",
  "releaseView.deleteHint": "このリリースと全デバッグファイルを削除します。既存イベントは保持されます。",
  "replay.stepBack": "前のフレーム",
  "replay.stepForward": "次のフレーム",
  "replay.speed": "再生速度",
  "detail.assignee": "担当者",
  "detail.unassigned": "未割り当て",
  "detail.lastReceived": "最終受信",
  "detail.evidence": "証拠",
  "detail.activity": "アクティビティ",
  "detail.event": "発生イベント",
  "detail.selectEvent": "イベントを選択",
  "detail.eventsFailed": "発生イベントを読み込めませんでした",
  "detail.eventFailed": "このイベントを読み込めませんでした",
  "detail.foreignEvent": "このイベントはこの問題に属していません",
  "detail.contextFailed": "周辺のイベントを読み込めませんでした",
  "detail.noEvents": "この問題には保持されているイベントがありません",
  "detail.addNote": "メモを追加",
  "detail.note": "メモ",
  "detail.saveNote": "メモを保存",
  "detail.activityLimit": "直近 100 件のアクティビティ",
  "detail.system": "システム",
  "detail.noActivity": "アクティビティの記録はありません",
  "detail.activity.note": "メモ",
  "detail.activity.assign": "割り当て",
  "detail.activity.status": "状態の変更",
  "detail.activity.regression": "再発",
  "queue.title": "問題",
  "queue.description": "記録されたイベントから問題を絞り込み、対応します",
  "queue.partialFailure": "{total} 件中 {failed} 件の変更に失敗しました。成功した変更は保存済みです。",
  "queue.events": "イベント",
  "queue.filteredTotals": "絞り込み条件に一致する全問題",
  "queue.latestReleases": "直近の発生バージョン",
  "queue.all": "すべて",
  "queue.search": "問題を検索",
  "queue.status": "状態",
  "queue.kind": "種類",
  "queue.sort": "並び順",
  "queue.impact": "影響度",
  "queue.newest": "最新の発生順",
  "queue.optionsFailed": "絞り込みの選択肢を読み込めませんでした",
  "queue.actionFailed": "一部の問題を更新できませんでした",
  "queue.selectPage": "このページを選択",
  "queue.shortcuts": "キーボードショートカット",
  "queue.noMatches": "一致する問題はありません",
  "queue.select": "選択",
  "queue.selectIssue": "{title} を選択",
  "queue.issue": "問題",
  "queue.users": "ユーザー",
  "queue.usersUnknown": "識別できるユーザーの記録がありません",
  "queue.lastSeen": "直近の発生 · 端末時刻",
  "queue.pageCount": "{total} 件中 {first}–{last} 件",
  "queue.previous": "前へ",
  "queue.next": "次へ",
  "queue.noMatchesHint": "絞り込みを解除すると、ほかの問題を確認できます",
  "setup.stepPending": "未開始",
  "setup.stepCurrent": "現在のステップ",
  "setup.stepComplete": "完了",
  "setup.stepError": "確認が必要",
  "setup.stepBlocked": "利用不可",
  "setup.stepSkipped": "スキップ済み",
  "setup.optional": "任意",
  "setup.back": "戻る",
  "setup.next": "次へ",
  "setup.installStepHint": "対象プラットフォームの SDK パッケージをインストール",
  "setup.configureStepHint": "テストを実行する前にエンドポイントと ingest キーを設定してください",
  "settings.allProjects": "すべてのプロジェクト",
  "settings.manageAccess": "アクセス権を管理",
  "settings.memberActionFailed": "メンバー操作を完了できませんでした",
  "settings.description": "プロジェクトの権限、認証情報、アカウントを管理",
  "settings.selectProject": "アクセス可能なプロジェクトを選択してトークンを管理してください",
  "settings.tokenRotation": "キーを更新するには、新しいキーを生成してクライアントを更新してから、古いキーを失効してください。",
  "settings.tokensLoadFailed": "トークンを読み込めませんでした",
  "settings.tokenActionFailed": "トークン操作を完了できませんでした",
  "settings.tokenScopeHint": "ingest キーは SDK イベントの送信に、api キーはこのプロジェクトへの自動化アクセスに使用します。",
  'settings.passwordSessionHint': '保存すると他の端末からログアウトします。このセッションは維持されます',
  'settings.passwordFailed': 'パスワードを変更できません。現在のパスワードを確認してください',
  'projects.conflict': 'プロジェクトが変更されました。再読み込みしてから保存してください',
  'projects.reload': 'プロジェクトを再読み込み',
  'projects.description': 'プロジェクトごとの接続状況、問題、リリースを確認',
  'projects.search': 'プロジェクトを検索',
  'projects.allPlatforms': 'すべてのプラットフォーム',
  'projects.edit': 'プロジェクトを編集',
  'projects.open': '問題を開く',
  'projects.healthUnavailable': 'ヘルスデータを取得できません',
  'projects.connected': '接続済み',
  'projects.loading': '状態を読み込み中',
  'projects.waiting': '最初のイベントを待機中',
  'projects.errors24h': '24 時間のエラー数',
  'projects.warnings24h': '24 時間の警告数',
  'projects.users24h': '24 時間のアクティブユーザー',
  'projects.latestRelease': '最新リリース',
  'projects.lastEvent': '最終イベント',
  'projects.noMatches': '該当するプロジェクトがありません',
  'projects.filterHint': '検索条件を変更するか、絞り込みを解除してください',
  'projects.clearFilters': '絞り込みを解除',
  'projects.actionFailed': 'プロジェクトの操作に失敗しました',
  'projects.confirmName': '削除するにはプロジェクト名を入力',
  'auth.sendFailed': 'リセットを要求できませんでした。もう一度お試しください',
  "settings.tab.instance": "インスタンス",
  "instance.recoveryValidation": "復元データの検証中",
  "instance.recoveryHint": "自動送信、監視、バックグラウンド処理、保存期間による削除は停止中です。復元データを確認し、旧インスタンスを停止してから、運用 CLI でこのインスタンスの再開を明示してください。",
  "instance.identity": "インスタンス情報",
  "instance.name": "インスタンス名",
  "instance.id": "インスタンス ID",
  "instance.origin": "公開 URL",
  "instance.version": "サーバーバージョン",
  "instance.status": "初期設定の状態",
  "instance.ready": "初期設定済み",
  "instance.pending": "初期設定が未完了",
  "instance.environment": "公開 URL と所有者アカウントはデプロイ環境で管理されます",
  "instance.checks": "環境チェック",
  "instance.checkHint": "データベース接続、ファイルの書き込み・読み取り・削除、公開 URL の設定を確認します。外部からの到達性やバックアップの復元は検証しません",
  "instance.check.database": "データベース接続",
  "instance.check.blobStorage": "ファイルの書き込み・読み取り・削除",
  "instance.check.durableStorage": "ファイルシステムストレージの設定",
  "instance.check.originValid": "公開 URL の設定",
  "instance.unchecked": "未確認",
  "instance.passed": "成功",
  "instance.failed": "失敗",
  "instance.lastCheck": "最終確認",
  "instance.runChecks": "チェックを実行",
  "instance.initialize": "初期設定を完了",
  "instance.refresh": "インスタンスを再読み込み",
  "instance.loadFailed": "インスタンスを読み込めませんでした",
  "instance.actionFailed": "操作を完了できませんでした",
  "instance.conflict": "設定が変更されました。インスタンスを再読み込みしてから再試行してください",
  "instance.checkRequired": "環境チェックを再実行してから初期設定を完了してください",
  "instance.checked": "チェックが完了しました",
  'common.close': '閉じる',
  'impact.events': '{count} 件',
  'impact.maximum': '識別済みユーザー1人あたり最大 {max} 件',
  'impact.users': '{count} 人',
  'nav.setup': 'アプリを接続',
  'setup.alerts': '通知を設定',
  'setup.appStartup': 'アプリの初期化',
  'setup.askOwner': 'インスタンスの所有者にプロジェクトの作成とアクセス権の付与を依頼してください',
  'setup.check': 'テストイベントを確認',
  'setup.checking': '確認中…',
  'setup.chooseProject': 'プロジェクトを選択',
  'setup.configureTitle': 'このプロジェクトに接続',
  'setup.copied': 'コピー済み',
  'setup.copy': 'コピー',
  'setup.copyCode': 'このコードをコピー',
  'setup.copyFailed': 'クリップボードを使えません。コードを選択してコピーしてください',
  'setup.createKey': '送信用キーを作成',
  'setup.createTitle': 'アプリのプロジェクトを作成',
  'setup.creating': '作成中…',
  'setup.developmentHint': 'この例は development 環境を使用します。本番では実際のリリース名を設定し、シンボルのアップロードと一致させてください。任意のビジュアルリプレイは明示的に有効化します。',
  'setup.endpoint': 'インスタンスの URL',
  'setup.failed': 'この手順を完了できませんでした',
  'setup.ingestKey': 'アプリの送信用キー',
  'setup.install.android': 'Kotlin ガイドのバージョンを依存関係に指定し、Application サブクラスを AndroidManifest.xml に登録してください。未登録では SDK が起動しません。',
  'setup.install.ios': 'Xcode で Swift Package を追加し、Sentori プロダクトを選択します。App の初期化処理または app delegate で起動してください。テストには Foundation の import が必要です。',
  'setup.install.rn': 'Expo は開発ビルドを使用します。Bare React Native はパッケージ追加後に iOS の pods もインストールしてください。両方の手順をガイドに掲載しています。',
  'setup.install.weapp': 'WeChat 開発者ツールで npm をビルドし、onLaunch で初期化します。テスト前にインスタンスのドメインを request 許可リストに追加してください。',
  'setup.install.web': '既存のフレームワークで利用できます。監視するコードより前に、ブラウザーのエントリーポイントで一度だけ初期化してください。',
  'setup.installTitle': 'プラットフォームを選んで導入',
  'setup.keyHint': 'アプリには送信用キーを使い、自動化用キーは含めないでください。生成したキーは一度だけ表示され、ブラウザーには保存されません。不要なキーは設定で失効できます。',
  'setup.localEndpoint': 'このアドレスはアプリを実行する端末自身を指します。実機にはアクセス可能なインスタンスの URL が必要で、PC の localhost はそのまま使えません。',
  'setup.nextHint': '対応する Source Map またはネイティブシンボルをアップロードし、通知もテストしてください。リプレイを有効にする前にマスキングを確認します。',
  'setup.nextTitle': '次のリリースの前に',
  'setup.notChecked': 'テスト実行後にここで確認してください',
  'setup.openIssue': 'テストの問題を開く',
  'setup.package': 'パッケージ · 導入ガイドを参照',
  'setup.platform': 'アプリのプラットフォーム',
  'setup.platformGuide': 'プラットフォームの導入ガイドを開く',
  'setup.progressHint': '受信とソースの読み取りは別々に確認します。キーの作成だけでは確認できません',
  'setup.progressTitle': '確認できたこと',
  'setup.receiptStatus': '今回のテストイベントを受信',
  'setup.received': '今回のテストイベントを受信しました',
  'setup.release': 'アプリのリリース',
  'setup.sourceHint': 'イベントは届きましたが、読み取れるソース位置は未確認です。問題を開き、このリリースのシンボルを確認してください。',
  'setup.sourceStatus': '読み取れるソース位置を確認',
  'setup.subtitle': 'SDK を導入し、このプロジェクトに接続して、アプリからテストイベントを送信します。このページを開いたまま進めてください。',
  'setup.symbolGuide': 'シンボルのアップロードガイド',
  'setup.terminal': 'ターミナル',
  'setup.testAction': '確認用のテストコード',
  'setup.testHint': '初期化後、仮のテストボタンなどから一度だけ実行します。アプリをクラッシュさせずにエラーを送信できます。確認後はテストコードを削除してください。',
  'setup.title': '最初のエラーを、原因がわかる形で',
  'setup.verifyTitle': 'アプリからテストイベントを送信',
  'setup.waiting': '今回のテストイベントは未受信です',
  'setup.waitingHint': '数秒待って再試行してください。届かない場合は URL、送信用キー、初期化位置、ネットワーク接続を確認します。既存の別イベントでは今回の接続確認は完了しません。',
  'shell.navigation': 'メインナビゲーション',
  'shell.openNavigation': 'ナビゲーションを開く',
  'shell.skip': '本文へ移動',
  'site.discover': 'Sentori は初めてですか？製品を見る',
  'site.language': '言語',
  'triage.back': '問題一覧に戻る',
  'triage.hideTimeline': 'タイムラインを閉じる',
  'triage.showTimeline': 'タイムラインを表示',
  'auth.backToSignIn': 'サインインに戻る',
  'auth.confirm': 'パスワード（確認）',
  'auth.missingToken': 'トークンなし。メール内のリンクから開いてください。',
  'auth.newPassword12': '新しいパスワード（12 文字以上）',
  'auth.resetDone': 'パスワードを更新しました——新しいパスワードでサインイン',
  'auth.email': 'メールアドレス',
  'auth.forgot': 'パスワードをお忘れですか',
  'auth.forgotHint': 'メールアドレスを入力すると、リセットリンクを送信します',
  'auth.password': 'パスワード',
  'auth.passwordTooShort': 'パスワードは8文字以上にしてください',
  'auth.passwordsDiffer': 'パスワードが一致しません',
  'auth.resetFailed': 'リセットに失敗しました — リンクの期限切れの可能性があります',
  'auth.resetPassword': 'パスワードをリセット',
  'auth.resetSent': 'そのアドレスが存在すれば、リセットリンクを送信しました',
  'auth.saving': '保存中…',
  'auth.sendReset': 'リセットリンクを送信',
  'auth.sending': '送信中…',
  'auth.setNewPassword': '新しいパスワードを設定',
  'auth.signIn': 'サインイン',
  'auth.signInFailed': 'ログイン失敗。メールアドレスとパスワードを確認。',
  'auth.signInTitle': 'Sentori にサインイン',
  'auth.signingIn': 'サインイン中…',

  'common.delete': '削除',
  'common.retry': '再試行',
  'inbox.awaitingFirstHint': 'このプロジェクトはまだ一度もイベントを受け取っていません。ingest トークンで SDK をこのインスタンスに向けると、issue がここに現れます。',
  'inbox.emptyNoProject': 'プロジェクト作成 → ingest トークン生成 → SDK をこのインスタンスへ。',
  'inbox.group.ignored': '無視',
  'inbox.group.open': '未解決',
  'inbox.group.resolved': '解決済み',
  'inbox.envFilter': '環境',
  'inbox.releaseFilter': 'リリース',
  'inbox.groupNew': '新規 · 24h',
  'inbox.groupRegressed': 'リグレッション',
  'inbox.loadFailed': '受信箱を読み込めませんでした',
  'inbox.selectedCount': '{n} 件選択中',

  'health.backend': 'バックエンド',
  'health.replay': 'リプレイ',
  'health.silent': 'イベントなし',

  'identity.copied': 'コピーしました',
  'identity.copyHint': 'ユーザーキー全体をコピー',

  'instruments.assertRan': '実行 {total} · 失敗 {failed}',
  'instruments.asserts': 'アサーション',
  'instruments.assertsEmpty':
    '本番アサーションはまだありません — sentori.assert(name, ok) が生存台帳を作ります。',
  'instruments.guardedIssue': '保護対象 issue',
  'instruments.colSamples': 'サンプル',
  'instruments.colPrewarmed': 'プリウォーム',
  'instruments.launch': '起動',
  'instruments.launchEmpty':
    'ステージ別起動データはまだありません — アプリが使用可能になった時点で sentori.launch.complete() を呼んでください（任意で sentori.launch.mark(name) のウェイポイント）。起動ごとに app.launch として集計されます。',
  'instruments.prewarmedTip': 'プリウォームのファントムサンプル。パーセンタイルから除外',
  'instruments.loadFailed': '計測パネルを読み込めませんでした',
  'instruments.noProject': 'プロジェクトがまだありません',
  'instruments.probeFired': '発火 {count}回 · 直近 {last}',
  'instruments.probeSilent': '{since} から沈黙。修正は維持。',
  'instruments.probes': 'プローブ',
  'instruments.probesEmpty':
    'トリップワイヤはまだありません — 修正したブランチに sentori.probe(ref) を置き、`sentori-cli probes sync` で登録します。',
  'instruments.colLastFail': '直近の失敗',
  'instruments.colLastSeen': '最終確認',
  'instruments.colName': '名前',
  'instruments.colRelease': 'リリース',
  'instruments.colStatus': 'ステータス',
  'instruments.volume': '{events} 件 · {users} 人',
  'instruments.volumeAnon': '{events} 件 · ユーザー不明',
  'instruments.colVolume': 'ボリューム',
  'instruments.traces': 'トレースポイント',
  'instruments.tracesEmpty': '観測点なし。sentori.trace(name) で経路到達を記録。',

  'issue.code': "スタックトレース",
  'issue.codeNone': 'このイベントにスタックはありません。ネイティブのクラッシュは自前で持ちます。手動送信の error は、文字列ではなく元の例外オブジェクトを sentori.error(e) に渡した場合にのみ付きます。',
  'issue.eventMoment': '{kind} 発生',
  'issue.notifyAffected': 'この人たちに通知',
  'issue.signals': 'ユーザーイベント',
  'issue.signalsNone': 'このイベントには行動シグナルが付いていません',
  'issue.replayScreensEmpty':
    'このビルドはピクセルリプレイが有効ですが、1 フレームも取得できていません —— ネイティブバイナリが JS SDK より古いか、キャプチャが失敗し続けています。ネイティブを再ビルドしてください。',
  'issue.replayScreensEmptyTip':
    'このビルドはピクセルリプレイを要求しましたが取得できていません —— ワイヤーフレームは常時オンの構造キャプチャによるものです。',
  'issue.replayWireframeTip':
    'このビルドは replayScreens が無効 — ワイヤーフレームは常時オンの構造キャプチャによるものです。',
  'issue.guardAnchored':
    '{release} で解決済み。そのリリース以降での再発のみが再オープンさせます。',
  'issue.guardProbeHint':
    '修正したブランチに sentori.probe(ref) を置いてください — 静かなプローブが修正維持の証明です。',
  'issue.guardUnanchored': 'バージョン未指定で解決。以降の再発で再オープン。',
  'issue.ignore': '無視',
  'issue.deviceClock': '端末時刻',
  'issue.loadFailed': 'この issue を読み込めませんでした',
  'issue.occurrences': '発生一覧',
  'issue.releaseRegressedHere': 'このリリースでリグレッション',
  'issue.releaseResolvedHere': 'このリリースで修正済みマーク',
  'issue.releasesTitle': 'リリース分布',
  'issue.reopen': '再オープン',
  'issue.replayFrom': '{when} の発生分の録画。最新イベントには録画なし。',
  'issue.replayNone':
    'このイベントにはリプレイが付いていません — SDK で replayScreens: true を有効にすると、直前の1分間の画面を記録できます。',
  'issue.resolve': '解決',
  'issue.resolveInRelease': '修正リリース',
  'issue.timeline': 'タイムライン',
  'nav.inbox': '受信箱',
  'nav.instruments': '計測',
  'nav.projects': 'プロジェクト',
  'nav.push': 'プッシュ',
  'nav.releases': 'リリース',
  'nav.settings': '設定',

  'notify.saveFailed': '通知設定を保存できませんでした',
  'notify.loadFailed': '通知設定を読み込めませんでした',
  'notify.onNewIssue': '新規 issue',
  'notify.onRegression': 'リグレッション',
  'notify.prefsHint': 'プロジェクト単位の自分宛メール設定。既定は全て有効。',
  'notify.prefsTitle': 'メールを受け取る条件',
  'notify.webhookTitle': 'Webhook',
  'notify.webhookHint':
    '新規 issue と再発をここにも POST します（{"subject", "body", "metadata"} 形式）。人ではなくプロジェクト単位で、送り先は部屋です。SMTP がなくても動きます。',
  'notify.webhookPlaceholder': 'https://hooks.example.com/services/…',
  'notify.webhookSave': '保存',
  'notify.webhookSaved': '保存しました',
  'notify.webhookFailed': 'webhook URL を保存できませんでした',
  'notify.webhookOwnerOnly': 'オーナーのみが表示・変更できます',
  'notify.smtpTitle': 'SMTP',
  'notify.smtpUnconfigured': 'SMTP 未設定。SENTORI_SMTP_HOST を設定すると有効。',
  'notify.testButton': 'テストメールを送信',
  'notify.testFailed': 'テストメール失敗。SMTP 設定とサーバーログを確認。',
  'notify.testSending': '送信中…',
  'notify.deliveryFailing': '通知が届いていません —— 直近 7 日で {count} 件失敗',
  'notify.lastDelivered': '最後に届いたのは',
  'notify.testSent': 'テストメール送信済み',
  'palette.placeholder': 'ページへ移動、または issue を検索…',


  'push.section.audience': 'オーディエンス',
  'push.audienceTitle': '送信対象',
  'push.audienceEditJson': 'JSON で編集',
  'push.audienceEditRows': '条件に戻る',
  'push.audienceBadJson': 'JSON として読めません',
  'push.joinAll': 'すべての条件に一致',
  'push.joinAny': 'いずれかの条件に一致',
  'push.sourceIssue': 'この問題に遭遇',
  'push.sourceTrait': 'ユーザー属性',
  'push.sourceDevice': 'デバイス情報',
  'push.sourceUser': 'ユーザー ID',
  'push.opIs': '＝',
  'push.opIsNot': '≠',
  'push.opIn': 'いずれか',
  'push.opPrefix': '前方一致',
  'push.opExists': '設定あり',
  'push.opVersionGte': 'バージョン ≥',
  'push.opVersionLte': 'バージョン ≤',
  'push.opGte': '≥',
  'push.opLte': '≤',
  'push.deviceFacts': 'デバイス情報',
  'push.audienceMessage': '送信内容',
  'push.confirmSend': '{n} 台に送信しますか。取り消し不可。',
  'push.audienceQueued': '{n} 台分をキューに入れました',
  'push.section.credentials': '認証情報',
  'push.section.delivery': '配信',
  'push.section.devices': 'デバイス',
  'push.statusAny': 'すべての状態',
  'push.testBody': '本文',
  'push.testSend': 'テスト送信',
  'push.testSubject': 'タイトル',
  'push.testTitle': 'テストを送る',
  'push.credentialsAdd': '認証情報を追加',
  'push.field.keyId': 'Key ID',
  'push.field.production': '環境',
  'push.field.secretKey': '秘密鍵',
  'push.field.subject': '連絡先',
  'push.field.teamId': 'Team ID',
  'push.field.topic': 'Bundle ID',
  'push.field.vapidPublicKey': 'VAPID 公開鍵',
  'push.hint.apns.keyId': '.p8 のファイル名で AuthKey_ に続く 10 文字',
  'push.hint.apns.production': '開発用プロファイルで署名したビルドはサンドボックスです',
  'push.hint.apns.secretKey': '.p8 全文を貼り付け。改行も含める。',
  'push.hint.apns.teamId': 'Apple Developer ポータルの右上',
  'push.hint.apns.topic': 'アプリの bundle id。Apple へは apns-topic として送信。',
  'push.hint.fcm.secretKey': 'Firebase ▸ プロジェクト設定 ▸ サービスアカウント ▸ 新しい秘密鍵を生成。',
  'push.hint.webpush.secretKey': 'VAPID の秘密鍵（PEM）',
  'push.hint.webpush.subject': 'プッシュサービスからの連絡先 mailto: または https:',
  'push.hint.webpush.vapidPublicKey': 'base64url。下の秘密鍵と対。',
  'push.option.production': '本番',
  'push.option.sandbox': 'サンドボックス',
  'push.placeholder.apns.keyId': 'ABC1234567',
  'push.placeholder.apns.secretKey': '-----BEGIN PRIVATE KEY-----\n…\n-----END PRIVATE KEY-----',
  'push.placeholder.apns.teamId': 'DEF7654321',
  'push.placeholder.apns.topic': 'com.example.app',
  'push.placeholder.fcm.secretKey': '{\n  "type": "service_account",\n  "project_id": …\n}',
  'push.placeholder.webpush.secretKey': '-----BEGIN PRIVATE KEY-----\n…\n-----END PRIVATE KEY-----',
  'push.placeholder.webpush.subject': 'mailto:alerts@example.com',
  'push.placeholder.webpush.vapidPublicKey': 'BEl62iUYgUiv…',
  'push.credentialsEmpty':
    'プロバイダの認証情報がまだありません —— 上に APNs キーまたは FCM サービスアカウントを貼ってください。なくてもデバイスは登録できますが、配信はできません。',
  'push.credentialsTitle': 'プロバイダ認証情報',
  'push.device': 'デバイス',
  'push.devicesEmpty': '端末なし。sentori.push.register() で登録。',
  'push.devicesTitle': 'デバイス',
  'push.failed24h': "24 時間の送信停止",
  'push.specHowTo': '取得',
  'push.specApnsTitle': 'iOS · APNs',
  'push.specFcmTitle': 'Android · FCM',
  'push.specWebpushTitle': 'Web · VAPID',
  'push.specApnsStep1': 'Apple Developer → 証明書・ID・プロファイル → キー',
  'push.specApnsStep2': '新規キーを作成し Apple Push Notifications service (APNs) を選択',
  'push.specApnsStep3': 'ダウンロード。一度きり、再取得は不可',
  'push.specFcmStep1': 'Firebase コンソール → プロジェクトの設定 → サービスアカウント',
  'push.specFcmStep2': '新しい秘密鍵を生成',
  'push.specFcmStep3': 'そのサービスアカウントに Firebase Cloud Messaging API Admin ロールがあることを確認',
  'push.specWebpushStep1': 'P-256 鍵ペアを自分で生成',
  'push.specWebpushStep2': '公開鍵はアプリへ、秘密鍵はここへ',
  'push.specFile': 'ファイル',
  'push.specFirstLine': '先頭行',
  'push.specSize': 'サイズ',
  'push.specMarker': '目印',
  'push.secretIssue.unrecognised': 'PEM でも JSON でもない',
  'push.credentialLabel': 'メモ',
  'projects.emptyTitle': 'プロジェクトがありません',
  'projects.emptyHint': 'イベント・リリース・プッシュ端末はプロジェクトに属します。上で名前を付けて始めてください。',
  'settings.createProjectFailed': 'プロジェクトを作成できませんでした',
  'push.section.integrate': '接続',
  'push.integrateEndpoint': 'エンドポイント',
  'push.integrateScopeNote': 'ingest では送信不可',
  'push.integrateMint': '生成',
  'push.integrateSend': '送信',
  'push.integrateCount': '件数見積',
  'push.integrateCountWhy': '同一のクエリ。キューには入らない。',
  'push.integratePoll': '結果',
  'push.integratePollWhy': '送信は sendId を返す。sent = ベンダー受理。delivered = 端末受信確認。',
  'push.retry': '再試行',
  'push.readinessTitle': 'セットアップ',
  'push.level.blocked': '配信不可',
  'push.level.warn': '欠け',
  'push.level.info': '参考',
  'push.check.no-device': '登録端末なし',
  'push.fix.no-device': 'sentori.push.register() を呼ぶ。失効 {quarantined} 台。',
  'push.check.no-credential': '{provider} · {devices} 台 · 認証情報なし',
  'push.fix.no-credential': '保存するまで配信不可',
  'push.check.queue-stalled': '{queued} 件滞留 · 最古 {minutes} 分',
  'push.fix.queue-stalled': 'ワーカーは 5 秒間隔。サーバーの push 有効を確認。',
  'push.check.no-identity': '{live} 台 · 識別子なし',
  'push.fix.no-identity': 'sentori.user() を呼ぶ。ユーザー/issue 指定は 0 件一致。',
  'push.check.no-traits': '{live} 台 · 属性なし',
  'push.fix.no-traits': 'sentori.user({ id, traits })。属性条件は 0 件一致。',
  'push.check.no-metadata': '{live} 台 · 端末情報なし',
  'push.fix.no-metadata': 'push.register({ metadata })。バージョン条件は 0 件一致。',
  'push.check.credential-unused': '{provider} 認証情報 · 該当端末なし',
  'push.fix.credential-unused': '端末があるはずなら、SDK が別種で登録している',
  'push.check.mass-quarantine': '失効 {quarantined} 台 · 稼働 {live} 台',
  'push.fix.mass-quarantine': '通常は認証情報が別アプリまたは別ホストを指している',
  'push.check.all-failing': '24h で {failed} 件全失敗',
  'push.fix.all-failing': 'ベンダー応答：{reason}',
  'push.check.apns-mixed-env': '{live} 台中 {sandbox} 台が Apple sandbox',
  'push.fix.apns-mixed-env': '端末の env ごとに配信。鍵は共通。',
  'crashFree.scope': '選択した App と環境の直近 24 時間のセッション。課題・バージョン・タグの絞り込みは適用されません',
  'crashFree.title': 'クラッシュフリーセッション',
  'crashFree.thin': 'セッションが少なく、この精度に意味はありません',
  'crashFree.counts': '{total} セッション中 {crashed} 件がクラッシュ',
  "crashFree.empty": "この期間のセッションデータはありません",
  'crashFree.users': 'クラッシュしなかったユーザー {pct}%',
  'crashFree.usersEmpty': 'まだ誰も識別されていません',
  'crashFree.usersTitle':
    '直近 {hours} 時間にセッションを 1 回以上開始したユーザー。2 つのリリースを使った人も 1 人として数えます。',
  'crashFree.sessionsTitle':
    '直近 {hours} 時間に開始したセッション。起動 1 回が 1 セッションなので、10 回起動した人は 10 と数えます。',
  'health.usersTitle': '直近 24 時間に何らかのイベントを送った実ユーザー数。問題に遭った人だけではありません。',
  'crashFree.trendFrom': '{hours} 時間前',
  'crashFree.trendLow': '最低 {pct}%',
  'crashFree.trendTitle':
    '直近 {hours} 時間の区間ごとのクラッシュフリー率。縦軸は {low}% から。線の途切れはセッションがなかった区間で、問題がなかった区間ではありません。',
  'crashFree.window': '直近 {hours} 時間',
  'platform.unknown': '不明（SDK がサーバーより新しい）',
  'platform.weapp': 'WeChat ミニプログラム',
  'releases.legend': 'シンボル化',
  'releases.legendBroken': "無効なファイルあり",
  'releases.crashFree': 'クラッシュなし',
  'releases.crashFreeNone': 'セッションなし',
  'releases.crashFreeTitle':
    '直近 30 日間、このリリースの {sessions} セッションのうち {pct}% がクラッシュしませんでした。セッションは送信する SDK から届きます。1 件もないリリースは比率ではなくダッシュを表示します。',
  'releases.delete': 'リリースを削除',
  'releases.deleteConfirm': '{name} を削除しますか？シンボリケーション成果物も一緒に削除され、再アップロードするまでこのリリースのスタックは復元できません。',
  'releases.deleteFailed': 'リリースを削除できませんでした',
  'releases.emptyTitle': 'リリースはまだありません',
  'releases.loadFailed': 'リリースを読み込めませんでした',
  'replay.empty': 'このリプレイにはフレームがありません',
  'replay.frameAlt': '{t} 秒時点のフレーム',
  'replay.loadFailed': 'リプレイを読み込めませんでした',
  'replay.pause': '一時停止',
  'replay.play': '再生',
  'replay.scrubber': 'リプレイ位置',
  'replay.title': 'セッションリプレイ',
  'releases.noArtifacts': 'シンボル化の成果物なし。スタックは難読化のまま：',

  'settings.adminEmail': '管理者メール',
  'settings.auditLoadFailed': '監査ログを読み込めませんでした',
  'settings.changePassword': 'パスワード変更',
  'settings.createAdmin': '管理者を作成',
  'settings.createProject': '作成',
  'settings.currentPassword': '現在のパスワード',
  'settings.deleteAdminConfirm':
    '管理者 {email} を削除しますか？セッションは即座に終了します。',
  'settings.deleteProjectConfirm':
    'プロジェクト {name} を削除しますか？イベントと issue もすべて消えます。',
  'settings.initialPassword': '初期パスワード（8文字以上）',
  'settings.language': '言語',
  'settings.mintToken': '生成',
  'settings.newPassword': '新しいパスワード（12 文字以上）',
  'settings.projectName': 'プロジェクト名',
  'settings.revoke': '失効',
  'settings.revokeConfirm':
    'トークン {name} を失効しますか？使用中のクライアントは即座に報告を停止します。',
  'settings.revoked': '失効済み',
  'settings.save': '保存',
  'settings.saved': '保存しました',
  'settings.tab.account': 'アカウント',
  'settings.roleOwnerScope': 'すべてのプロジェクト、および管理者・トークン・監査ログ',
  'settings.roleAdminScope': '下でチェックしたプロジェクトのみ',
  'settings.tab.audit': '監査',
  'settings.tab.notifications': '通知',
  'settings.tab.push': 'プッシュ',
  'settings.tab.tokens': 'トークン',
  'settings.tab.users': '管理者',
  'settings.colAction': '操作',
  'settings.colActor': '実行者',
  'settings.colCreated': '作成',
  'settings.colLastLogin': '最終ログイン',
  'settings.colRole': 'ロール',
  'settings.colTarget': '対象',
  'settings.colToken': 'トークン',
  'settings.colWhen': '日時',
  'settings.fieldProject': 'プロジェクト',
  'settings.fieldScope': 'スコープ',
  'settings.tokenName': 'トークン名',
  'settings.tokenOnce': '表示は一度のみ。今コピーを。',
  'settings.usersLoadFailed': '管理者一覧を読み込めませんでした',
  'strip.inspectHint': "マーカーにカーソルを合わせるかフォーカスして詳細を表示",
  'stack.sourceCount': "{total} フレーム中 {n} フレームにソースあり",
  'releaseView.identifier': '元のリリース識別子',
  'stack.debugFiles': "このリリースのデバッグファイルを確認",
  'stack.nativeSourceMissing': "ソースの特定には、このビルドの UUID に一致するデバッグファイルが必要です。コードの表示にはソースバンドルも必要です",
  'stack.sourceMissing': "このフレームのソースは未取得です。このリリースの source map またはソースバンドルを確認してください",
  'stack.sourceReady': "ソース",
  'stack.sourceUnavailable': "ソース未取得",
  'stack.locationUnresolved': "位置未解決",
  'stack.locationMissing': "ソースファイルと行番号が未解決です。このリリースのデバッグファイルを確認してください",
  'stack.nativeLocationMissing': "ソースファイルと行番号が未解決です。デバッグファイルがこのビルドの UUID に一致するか確認してください",
  'stack.binaryUuid': "ビルド UUID",
  'stack.address': "アドレス",
  'stack.libraryFrames': 'ライブラリフレーム {n} 件',
  'stack.libraryFramesOpen': 'ライブラリフレーム',
  'stack.minified': 'minified',
  'stack.truncated': '… 残り {n} フレーム',

  'table.empty': 'まだ何もありません',

  'shell.bootFailed': 'セッションを読み込めませんでした',
  'shell.projectsFailed': 'プロジェクトを読み込めませんでした',
  'shell.loading': '読み込み中…',

  'strip.events': 'イベント',
  'strip.frames': 'フレーム',
  'strip.signals': '操作',
  'theme.dark': 'ダーク',
  'theme.label': 'テーマ',
  'theme.light': 'ライト',
  'theme.system': 'システムに従う',
  'shell.roleAdmin': '管理者',
  'shell.roleOwner': 'オーナー',
  "transfer.title": "プロジェクトの移行",
  "transfer.description": "セルフホストの Sentori から Cloud または別のインスタンスへ移し、実際のデータ受信を確認します",
  "transfer.prepare": "移行元と移行先を指定",
  "transfer.prepareHint": "両方のインスタンスでオーナーとしてこのページを開きます。移行先の識別ファイルを保存し、移行元で読み込みます",
  "transfer.saveIdentity": "インスタンスの識別ファイルを保存",
  "transfer.receive": "移行を受け入れる",
  "transfer.start": "移行を開始",
  "transfer.scope": "移行するデータ",
  "transfer.scopeHint": "プロジェクトの履歴、イベント、セッション、リプレイ、リリース、タスクを暗号化して移します。トークン、パスワード、メンバー権限、Push 認証情報、自動化の設定は移行先で再設定してください",
  "transfer.limit": "アップロードは 1 回 1 GiB までです。必要に応じてプロジェクトを分けてください。単一プロジェクトが上限を超える場合は運用担当者による移行が必要です。Cloud のプロジェクト数とストレージ容量の上限も適用されます",
  "transfer.empty": "移行はまだありません",
  "transfer.id": "移行 ID",
  "transfer.source": "移行元",
  "transfer.target": "移行先",
  "transfer.step.copy": "履歴をコピー",
  "transfer.step.cutover": "最終コピーと切り替え",
  "transfer.step.evidence": "実データを確認",
  "transfer.sourceHint": "移行元を稼働したまま初回コピーを出力します。移行先で取り込んだ後、移行元の書き込みを停止して最終コピーを出力します。旧クライアントのために移行元を稼働させておいてください",
  "transfer.targetHint": "初回コピー、書き込み停止後の最終コピーの順で取り込みます。最終コピーの取り込みに成功してから有効化します。過去のデータは SDK の切り替え確認には使えません",
  "transfer.saveDescriptor": "移行情報ファイルを保存",
  "transfer.sdkHint": "最終コピーの取り込み後、移行先で新しい取り込みトークンを作成し、SDK の接続先とプロジェクト設定を更新します。Push と自動化は別途設定してください",
  "transfer.evidenceHint": "有効化後、各プロジェクトが SDK から受信した最初の新規イベントを表示します。すべてのプロジェクトで受信してから検証してください",
  "transfer.waitingEvent": "SDK の新規イベントを待っています",
  "transfer.copyPackage": "初回コピー",
  "transfer.finalPackage": "最終コピー",
  "transfer.forwarded": "転送成功リクエスト数",
  "transfer.failed": "転送失敗リクエスト数",
  "transfer.expires": "転送の有効期限",
  "transfer.lastSeen": "最後の転送リクエスト",
  "transfer.noTraffic": "転送リクエストはまだありません",
  "transfer.rollback": "切り戻しとデータ保全の計画",
  "transfer.invalidDescriptor": "正しい移行先のファイルを読み込んでください。移行元ではプロジェクトを 1 つ以上選択してください",
  "transfer.sourceCreateHint": "移行先で保存した識別ファイルを読み込み、移行するプロジェクトを選択します",
  "transfer.targetCreateHint": "移行元で保存した移行情報ファイルを読み込みます。このインスタンスが移行先として指定されている必要があります",
  "transfer.identityFile": "移行先の識別ファイル",
  "transfer.descriptorFile": "移行情報ファイル",
  "transfer.identityContent": "移行先の識別情報",
  "transfer.descriptorContent": "移行情報",
  "transfer.incomplete": "必要な項目を入力してください",
  "transfer.packageHint": "暗号化パッケージと復旧キーを安全に保管してください。出力ごとに新しいキーを使えます。取り込みにはそのパッケージに対応するキーが必要です",
  "transfer.sealHint": "受け付け済みの書き込み完了を待ってから、選択した移行元プロジェクトへの書き込みを停止します。続いて最終コピーを出力してください。転送を設定するまで旧 SDK のリクエストは再試行されます。このページでは書き込み停止を解除できません",
  "transfer.activateHint": "有効化すると、取り込んだプロジェクトへの書き込みを受け付けます。後で切り戻す場合は、移行先の新規データをすべて保全・照合してから移行元の書き込みを再開してください",
  "transfer.rollbackHint": "担当者、バックアップ先、移行先の新規データの保全方法、トラフィックを戻す前の照合手順を記録してください（30〜8,000 バイト）",
  "transfer.cutoverAck": "データ保全の計画を作成し、切り戻す前に移行先の新規データを照合する必要があることを確認しました",
  "transfer.sdkAck": "SDK の接続先、プロジェクト、トークンを更新しました。旧クライアントへの転送が必要な間は移行元を稼働させます",
  "transfer.cancelAck": "切り替え前の移行を中止します。移行先に取り込んだ一時プロジェクトは削除されます",
  "transfer.tailHint": "最終コピーの取り込み後に移行先で作成した新しい取り込みトークンを使います。移行先の識別情報を検証してから旧クライアントのテレメトリを転送します。Push は別途設定してください。転送期間は最大 90 日で、ここから更新できます",
  "transfer.targetOrigin": "移行先の HTTPS オリジン",
  "transfer.targetToken": "移行先の新しい取り込みトークン",
  "transfer.days": "転送日数（1〜90）",
  "transfer.action.export_copy": "初回コピーを出力",
  "transfer.action.seal": "移行元の書き込みを停止",
  "transfer.action.export_final": "最終コピーを出力",
  "transfer.action.upload_copy": "初回コピーを取り込む",
  "transfer.action.upload_final": "最終コピーを取り込む",
  "transfer.action.activate": "移行先を有効化",
  "transfer.action.verify": "受信イベントを検証",
  "transfer.action.complete": "移行を完了",
  "transfer.action.cancel": "移行を中止",
  "transfer.action.tail": "旧クライアントを転送",
  "transfer.state.copying": "初回コピー待ち",
  "transfer.state.copied": "初回コピー完了",
  "transfer.state.sealed": "移行元の書き込み停止済み",
  "transfer.state.ready": "最終コピー完了",
  "transfer.state.active": "移行先が有効",
  "transfer.state.observing": "実トラフィックを確認中",
  "transfer.state.completed": "移行検証済み",
  "transfer.state.cancelled": "中止済み",
  "transfer.state.attention": "確認が必要",

  "transfer.ownerOnly": "プロジェクトの移行はインスタンスのオーナーのみ管理できます",

  "filters.appType": "App タイプ",
  "filters.platform": "プラットフォーム",
  "filters.source": "タグの取得元",
  "filters.context": "コンテキスト",
  "filters.tags": "イベントタグ",
  "filters.key": "タグ名",
  "filters.value": "タグ値",
  "filters.add": "条件を追加",
  "filters.active": "適用中のタグ条件",
  "filters.remove": "{key} の条件を解除",
  "filters.emptyValue": "（空の値）",
  "filters.sameEvent": "すべての条件が同じイベントに一致する必要があります。appType などの業務属性はタグから選択できます",
  "filters.invalid": "フィルターのリンクが無効です。条件を解除してください",

  "charts.dimension": "観測項目",
  "charts.plot": "グラフ",
  "charts.table": "データ表",
  "charts.export": "CSV を出力",
  "charts.failed": "グラフを表示できません",
  "charts.empty": "観測データはまだありません",
  "charts.emptyHint": "条件に一致するデータを受信すると表示されます",
  "workbench.overview": "概要",
  'workbench.filteredTasks': '絞り込みに一致するすべてのタスク',
  "workbench.activeTasks": "進行中のタスク",
  "workbench.reviewTasks": "レビュー・検証待ち",
  "workbench.doneTasks": "完了",
  "workbench.overdueTasks": "期限超過",
  "workbench.tasksEmptyHint": "タスクを作成するか問題から修正を開始して、レビューと検証を追跡できます",
  "workbench.firstTask": "タスクを作成",
  "workbench.monitoredServices": "監視対象サービス",
  "workbench.projectScope": "現在のプロジェクト",
  "workbench.openIncidents": "未復旧の障害",
  "workbench.searchServices": "サービスを検索",
  "workbench.monitorsEmptyHint": "サービスのチェック先を追加して、可用性、応答時間、障害からの復旧を確認できます",
  "workbench.firstMonitor": "最初の監視を追加",
  "workbench.monitorLatencyHint": "最近成功したチェックの応答時間。失敗したリクエストは空白で表示し、結果は下の履歴に記録します",
  "workbench.instrumentsDescription": "イベントの動向、起動性能、計測シグナルからリリースの変化を確認",
  "workbench.searchInstruments": "名前・リリースを検索",
  "workbench.window": "観測期間",
  "workbench.lastHours": "過去 {hours} 時間",
  "workbench.launchChartHint": "過去 {hours} 時間のリリース別起動時間の分位数。プリウォーム起動を除外",
  "workbench.eventActivity": "イベントの推移",
  "workbench.receivedWindow": "過去 {hours} 時間に受信したデータ",
  "workbench.topTraces": "選択期間内の件数が多い追跡ポイントを最大 12 件表示",
  "workbench.errorEvents": "エラーイベント",
  "workbench.warningEvents": "警告イベント",
  "workbench.cumulativeHint": "選択した名前とリリースの累積値を最大 200 行、グラフには先頭 12 件表示。期間指定はイベント推移、追跡、起動性能に適用",
  "workbench.passed": "成功",
  "workbench.failed": "失敗",
  "workbench.probeFires": "プローブの発火",
  "workbench.registered": "登録日時",
  "workbench.traceWindow": "過去 {hours} 時間に受信したデータ。最大 200 件の追跡ポイントを表示",

};
